import React, { lazy, Suspense, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useQuery from "../../Utils/hooks/useQuery";
import PubSub, { Message } from "../../Utils/pubSub";
import { setConfigs, setProductCols } from "../../Store/auth/authSlice";
import { setAddress, setCartId } from "./store/elementsSlice";
import { defaultAddress } from "../../Utils/address";
import isEqual from "fast-deep-equal/es6";
import {useIsDemo} from "../../Utils/hooks/useIsDemo";

const Elements = () => {

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const query = useQuery()

  const groupingId = query.get('p');

  const cartId = query.get('cartId');

  const isDemo = useIsDemo()

  useEffect(()=>{
    if (cartId && isDemo) {
      dispatch(setCartId(cartId))
    }
  },[cartId, isDemo])

  

  const {
    liquidToken,
    currentRouteKey,
    element,
    productCols,
    configs,
    dynamicStyles,
    env
  } = useSelector(state => state.auth, isEqual)

  // Use specific selectors to avoid re-render issues
  const loading = useSelector((state) => state.elements.loading)
  const liquid = useSelector((state) => state.elements.liquid)
  const address = useSelector((state) => state.elements.address)
  const addressActive = useSelector((state) => state.elements.addressActive)
  const addressUpdated = useSelector((state) => state.elements.addressUpdated)
  
  // Get secure from auth state, not elements state
  const { secure } = useSelector((state) => state.auth)

  const Element = useMemo(() => {
    const currElement = currentRouteKey.includes('elements') ?
      currentRouteKey.split('.')[1] : '';

    if (!loading && element && element !== '') {
      if (currElement === 'product') return lazy(() => import('./Product'))
      if (currElement === 'cart') return lazy(() => import('./Cart'))
    }

    return lazy(() => import('Components/shared/loaders/Plain'))
  }, [loading, element])

  useEffect(() => {
    if (isDemo) {
      dispatch(setAddress(defaultAddress));
    }
  }, [dispatch, isDemo]);

  useEffect(() => {
    const currElement = currentRouteKey.includes('elements') ? currentRouteKey.split('.')[1] : '';
    function updateConfigs(configs){
      if (!configs) return;

      const { element } = configs

      if (element[currElement]) {
        dispatch(setProductCols(element.product.general.details ? 2 : 1))
        dispatch(setConfigs(element[currElement]));
      }
    }

    if (isDemo) {
      PubSub.subscribe(Message.SetConfigs, updateConfigs);
    }

    PubSub.publish(Message.Initialized, { element: currElement });

    return () => PubSub.unsubscribe(Message.SetConfigs, updateConfigs);
  }, [currentRouteKey, dispatch, isDemo])

  useEffect(() => {
    if (!secure) navigate('/not-available')
  }, [navigate, secure])

  return (
    <Suspense>
      <Element
        configs={configs}
        groupingId={groupingId}
        address={address}
        addressActive={addressActive}
        addressUpdated={addressUpdated}
        env={env}
        liquid={liquid}
        liquidToken={liquidToken}
        loading={loading}
        dynamicStyles={dynamicStyles}
        productCols={productCols}
      />
    </Suspense>
  )
}

export default Elements
